import script from "./AutoTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./AutoTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./AutoTooltip.vue?vue&type=style&index=0&id=780feb22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-780feb22"]])

export default __exports__